import React from "react";
import { Col } from "react-bootstrap";
import { styled } from "@mui/material/styles";
import Grid from "@mui/material/Grid2";
import Paper from "@mui/material/Paper";
import Box from "@mui/material/Box";
const ReportItem = ({ title, onClick }) => {
  const reportClick = () => {
    if (onClick) onClick();
  };

  const Item = styled(Paper)(({ theme }) => ({
    backgroundColor: "#fff",
    ...theme.typography.body2,
    padding: theme.spacing(1),
    textAlign: "center",
    color: theme.palette.text.secondary,
    ...theme.applyStyles("dark", {
      backgroundColor: "#1A2027",
    }),
  }));

  return (
    <Col md={4} sm={6} xs={6} className="mb-2">
      <div className="border text-center p-2" onClick={(e) => reportClick()}>
        <a>{title}</a>
      </div>
    </Col>
  );
};
export default ReportItem;
